import { StepEnum } from '../../../../../components-library/checkout/CheckoutSteps';

export default {
  steps: {
    [StepEnum.OrderConfirmation]: 'Riepilogo ordine',
    [StepEnum.OrderPayment]: 'Pagamento',
  },
};
